// extracted by mini-css-extract-plugin
module.exports = {"DropdownMenuContainer":"DropdownMenu_DropdownMenuContainer__nIRWt","DropdownMenu":"DropdownMenu_DropdownMenu__fXOLu"};